module.exports = {
  VirtualTour: {
    background_color: "Arka Plan Rengi",
    border_color: "Çerçeve Rengi",
    border_size: "Çerçeve Genişliği",
    border_style: "Çerçeve Stili",
    box_style: "Kutu Stili",
    Coords: "Koordinatlar",
    opacity: "Opaklık",
    padding: "Alan",
    PluginName: "Google Harita",
    radius: "Radyan",
    center: "Merkez",
    Zoom: "Zoom",
    map: "Harita",
    message_mark_error: "Yanlış bir değer seçtiniz.  Sayılar virgül ile ayrılmalıdır",
    message_mark_xy:
      "Yanlış bir değer seçtiniz. Virgülle ayrılmış iki sayı girmelisiniz. Örn. 4.56,90.76",
    message_mark_xyp:
      "Yanlış bir değer seçtiniz. Virgülle ayrılmış üç sayı girmelisiniz. Örn. 4.56,90.76,1",
    Search: "Yer Ara...",
  },
};
